import NationSelectModal from '@/components/NationSelectModal';
import RpIcon from "@/components/RpIcon";
import { getNationIcon } from "@/utils/utils";
import { Stack, Typography, useTheme } from '@mui/material';
import { useBoolean } from "ahooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const NationSelect = (props) => {
  const { onSelect, isCompact, selected, variant, showAreaCode, disabled, isBindMobile, isBillingAddress, isShippingAddress } = props;
  const theme = useTheme()
  const {countries, appVersion} = useSelector((state) => state.app);
  const [nation, setNation] = useState(null)
  const [nationSelectModalShow, nationSelectModalShowOperate] = useBoolean(false)

  useEffect(() => {

    if (selected) {
      setNation(selected)
      // onSelect && onSelect(selected)
    } else {

      if (!countries || countries.length <= 0) {
        return
      }

      const ipCountryCode = appVersion?.locationRisk?.countryIsoCode;
      let defaultCountry = null;
      if (ipCountryCode && countries?.length) {
        defaultCountry = countries.find(country => country.code?.toUpperCase() == ipCountryCode.toUpperCase());
      }
      let _countries = []
      let __countries = []

      if (isBindMobile) {
        __countries = countries.filter(_ => {
          return _.isSupportKyc == 1
        })
      } else if (isBillingAddress) {
        __countries = countries.filter(_ => {
          return _.isSupportBilling == 1
        })
      } else if (isShippingAddress) {
        __countries = countries.filter(_ => {
          return _.isSupportShipping == 1
        })
      } else {
        __countries = countries
      }
      if (!defaultCountry && countries?.length) {
        defaultCountry = __countries[0];
      }
      setNation(defaultCountry);
      onSelect && onSelect(defaultCountry)
    }
  }, [selected, appVersion, countries]);

  const _onSelect = (item) => {
    setNation(item?.value)
    onSelect && onSelect(item?.value)
  }
  return (<>
    <Stack sx={{ opacity: disabled ? '0.6' : 1 }}>
      <Stack
        sx={{ padding: '0 16px', height: '48px',borderRadius:"6px",
          border: variant === 'borderless' ? 'none' : `0.5px solid ${theme.palette.text.tertiary}`, }}
        direction="row" alignItems="center" justifyContent="space-between" spacing={1} onClick={() => {
        if (disabled) return;
        nationSelectModalShowOperate.setTrue()
      }} {...props}>
        <Stack direction="row" spacing={1} alignItems="center">
          {nation && <img
            style={{display: 'block', width: '30px', height: '30px'}}
            src={getNationIcon(nation)} />}
          {showAreaCode && <Typography>{nation?.areaCode}</Typography> }
          {!isCompact && <Typography>{nation?.name}</Typography>}
        </Stack>
        <RpIcon icon="arrow-down-simple" size={20}/>
      </Stack>
    </Stack>
    <NationSelectModal
      isShippingAddress={isShippingAddress}
      isBillingAddress={isBillingAddress}
      isBindMobile={isBindMobile}
      showAreaCode={showAreaCode}
      // selected={selected}
      isCompact={isCompact}
      onSelect={_onSelect}
      open={nationSelectModalShow} onClose={nationSelectModalShowOperate.setFalse} />
  </>)
}

export default NationSelect